import { Component, OnInit, Input } from '@angular/core';
import { Question } from 'app/shared/models/question';
import { QuestionActionService } from '../services/question-action.service';
import { CopyClipboardService } from 'app/shared/services/copy-clipboard.service';

@Component({
  selector: 'app-scale-questions-list',
  templateUrl: './scale-questions-list.component.html'
})
export class ScaleQuestionsListComponent implements OnInit {
  @Input() Questions:Question[];
  @Input() QuestionActions:any[];
  @Input() flagPrompts:boolean;
  @Input() displayScale:boolean;

  public QuestionDisplays:any[];
  private hasThirdColumn = false;
  public hasQuestionActions = true;
  
  constructor(private actionService:QuestionActionService, private copyClipboardService:CopyClipboardService) { 
    // by default flag the prompts
    this.flagPrompts = true;
    this.hasThirdColumn = false;
    this.hasQuestionActions = false;
    this.displayScale = false;
    this.QuestionActions = [];
  }

  ngOnInit() {
    let actionsByQuestionId = (this.QuestionActions || []).reduce((prev, curr) => { prev[curr.question.id] = curr; return prev;}, {});
    if (this.QuestionActions && this.QuestionActions.length) {
      this.hasQuestionActions = true;
      this.hasThirdColumn = true;
    }
    this.QuestionDisplays = this.Questions.map(q => {
      let display:any = {prompt: q.prompt, answerDisplayText: q.answerDisplayText, scale:q.assessment_scale.name}
      if (actionsByQuestionId[q.id]) {
        display.action = actionsByQuestionId[q.id];
        display.actionLabel = display.action.label;
      }
      display.isFlaggedForReview = this.flagQuestion(q);
      display.computedScore = q.getComputedScore();
      
      return display;
    });
    this.hasThirdColumn = this.displayScale == true;
  }

  public copyTable() {
    /**
     * <div class="cell-data col-8 col-md-9" *ngIf="!HasThirdColumn">Question</div>
        <div class="cell-data col-4 col-md-3" *ngIf="!HasThirdColumn">Answer</div>

        <div class="cell-data col-7 col-md-8" *ngIf="HasThirdColumn">Question</div>
        <div class="cell-data col-2 col-md-2" *ngIf="HasThirdColumn">Answer</div>
        <div class="cell-data col-2 col-md-2" *ngIf="HasThirdColumn && hasQuestionActions">Action</div>
        <div class="cell-data col-2 col-md-2" *ngIf="HasThirdColumn && displayScale">Scale</div>
     */
    let copyTable = [];
    copyTable.push(["Question", "Answer"]);
    if (this.hasThirdColumn && this.displayScale) {
      copyTable[0].push("Scale");
    }
    if (this.QuestionDisplays.length) {
      this.QuestionDisplays.forEach(qd => {
        let row = [];
        row.push('"' + qd.prompt + '"');
        row.push('"' + qd.answerDisplayText + '"');
        if (this.hasThirdColumn && this.displayScale) {
          row.push('"' + qd.scale + '"');
        }
        copyTable.push(row);
      });
    }
    this.copyClipboardService.copyTableToText(copyTable);
  }

  public get HasThirdColumn() {
    return this.hasThirdColumn;
  }

  public shouldDisplayScale(scale) {
    return this.displayScale === true;
  }

  public shouldDisplayEmptyActionColumn(question:{prompt:string,answerDisplayText:string,action:string}) {
    if (!this.displayScale && this.hasQuestionActions) {
      return question.action === "" || question.action === undefined;
    }
    return false;
  }

  public shouldDisplayActionColumn(question:{prompt:string,answerDisplayText:string,action:string}) {
    if (!this.displayScale && this.hasQuestionActions) {
      return question.action !== "" && question.action !== undefined;
    }
    return false;
  }

  public flagQuestion(question:Question) {
    return this.flagPrompts && question.isFlaggedForReview;
  }

  public handleAction(questionDisplay:any) {
    console.log("Handling action: ", questionDisplay.action);
    this.actionService.handleAction(questionDisplay.action);
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/scale-questions-list/scale-questions-list.component.ts